'use strict'

import React from 'react';
import uuid from 'uuid';

import AreaForm from '../components/AreaForm.jsx'
import ProjectMenu from '../components/ProjectMenu.jsx';
import Layout from '../Layout.jsx';
import FormattedContent from '../components/FormattedContent.jsx';

import sendCommand from '../../app/utils/sendCommand.js';

import formDefinition from './formDefinition.js';
import Translations from '../../app/utils/translations.js';

let translations=new Translations([
  require('./labels/english.js'),
  require('./labels/norwegian.js')
]);

class BenefitSummary extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props);
    return (
      <div style={{fontFamily:"Arial, Verdana, Geneva, sans-serif", fontSize:"10pt", fontStyle:"italic"}}>
        <p>
          <b>{labels.strategy.fields.reasons.title}</b><br/>
          <FormattedContent value={this.props.reasons}/>
        </p>
        <b>{labels.options.title}</b>
        <table>
          <thead>
            <tr style={{backgroundColor:"#7f7f7f", color: "white"}}>
              <th>{labels.options.fields.doNothing.title}</th>
              <th>{labels.options.fields.doMinimal.title}</th>
              <th>{labels.options.fields.doSomething.title}</th>
            </tr>
          </thead>
          <tbody>
            <tr style={{backgroundColor: "#f5f5f5"}}>
              <td style={{verticalAlign:"top"}}><FormattedContent value={this.props.doNothing}/></td>
              <td style={{verticalAlign:"top"}}><FormattedContent value={this.props.doMinimal}/></td>
              <td style={{verticalAlign:"top"}}><FormattedContent value={this.props.doSomething}/></td>
            </tr>
          </tbody>
        </table>
        <div style={{paddingTop:10}}>
          <b>{labels.benefits.title}</b><br/>
          {this.props.benefits!==undefined && this.props.benefits.length>0 ? (
            <ul>
              {this.props.benefits.map(benefit=>
                <li key={benefit.title}>{benefit.title}</li>
              )}
            </ul>
          ) : null}
        </div>
        <div style={{paddingTop:10}}>
          <b>{labels.returnOnInvestment.title}</b><br/>
          <p>
            <FormattedContent value={this.props.projectPlanSummary}/>
          </p>
          <p>
            <FormattedContent value={this.props.investmentAppraisal}/>
          </p>
          <p>
            <FormattedContent value={this.props.risks}/>
          </p>
        </div>
      </div>
    );
  }
}

export class BusinessCase extends React.Component {
  constructor(props) {
    super(props);
    let businessCase=Object.assign({},this.props.project.businessCase,{
            id: this.props.project.businessCase!==undefined ? "definedBusinessCase" : undefined,
            _progress:"summary"
          });
    if (businessCase.benefits===undefined) {
      businessCase.benefits=[];
    }

    this.state={
      businessCase: businessCase,
      lastSaved:businessCase,
      selected: 0
    };
    this.warningOnLeave=this.changeWarningOnLeave.bind(this)
  }

  showDetails(details) {
    this.setState({details:details});
  }

  updateDetails(content) {
    if (content.id!==undefined) {
      let businessCase=Object.assign({},this.state.businessCase,{
        [this.state.details.field]:this.state.businessCase[this.state.details.field].map(item=>
          item.id===content.id ? Object.assign({},item,content) : item
        )
      });
      this.setState({businessCase:businessCase, details:undefined,selected:2, modified:true});
    } else {
      let businessCase=Object.assign({},this.state.businessCase,{
        [this.state.details.field]:this.state.businessCase[this.state.details.field].concat(
          Object.assign({},content,{id: uuid.v4()})
        )
      });
      this.setState({businessCase:businessCase, details:undefined,selected:2, modified:true});
    }
  }

  canceledDetails() {
    this.setState({details:undefined});
  }

  showSummary(tab,details) {
    return tab==="summary" ? (<BenefitSummary {...this.props} {...details.values}/>) : null;
  }

  updateBusinessCase(businessCase) {
    let updatedBusinessCase=Object.assign({},this.state.businessCase,{
      _progress:undefined,
      benefits: this.state.businessCase.benefits!==undefined ? this.state.businessCase.benefits.map(item=>Object.assign({},item,{_progress:undefined})) : undefined
    });
    sendCommand({type: "updateBusinessCase", project: {id: this.props.project.id}, businessCase: updatedBusinessCase})
      .then(response=>{
        this.setState({
          businessCase:Object.assign({},this.state.businessCase,{
            id: "definedBusinessCase",
            _currentProgress: businessCase._progress
          }),
          modified:undefined,
          lastSaved:this.state.businessCase
        });
      })
      .catch(error=>{
        alert("Could not save business case, got "+error+" "+error.stack+" "+JSON.stringify(error));
      });
  }

  handleFieldChange(fieldName) {
    return (event)=>{
      let labels=translations.getTranslation(this.props);
      var value=event.target.value;
      this.setState({
        businessCase:Object.assign({},this.state.businessCase,{
          [event.target.name]:value
        }),
        modified:true
      });
    };
  }

  hasChanged(lastSaved) {
    return formDefinition.map(area=>
      area.fields!==undefined && area.fields.map(field=>
        JSON.stringify(lastSaved[field.name])!==JSON.stringify(this.state.businessCase[field.name])
      )
      .reduce((value,result)=>result || value)
    ).reduce((value,result)=>result || value);
  }

  changeWarningOnLeave(e) {
    if (this.hasChanged(this.state.lastSaved)) {
      e.returnValue="Do you want to keep changes?";
      return "Do you want to keep changes?";
    }
  }

  componentDidMount() {
    console.log("Mount warning");
    window.addEventListener("beforeunload", this.warningOnLeave);
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload",this.warningOnLeave);
  }


  render() {
    let labels=translations.getTranslation(this.props).general;
    return (
      <div style={{paddingTop: 20, display:"flex", justifyContent:"center"}}>
        <div style={{width:1016}}>
          {this.state.details!==undefined ? (
            <AreaForm key="details"
              {...this.props}
              display="tab"
              areas={translations.createTranslatedForm(this.state.details.form,this.props.language,this.props.variant)}
              item={this.state.details.item}
              selected={0}
              label={labels.benefit}
              onUpdate={this.updateDetails.bind(this)}
              modified={true}
              onCancel={this.canceledDetails.bind(this)}
            />
          ) : (
            <AreaForm key="businessCase"
              {...this.props}
              areas={translations.createTranslatedForm(formDefinition,this.props.language,this.props.variant)}
              display="tab"
              item={this.state.businessCase}
              selected={this.state.selected}
              modified={this.state.modified}
              label={translations.getTranslation(this.props).general.businessCase}
              handleFieldChange={this.handleFieldChange.bind(this)}
              onUpdate={this.updateBusinessCase.bind(this)}
              onAddEntry={this.showDetails.bind(this)}
              onEditEntry={this.showDetails.bind(this)}
              summary={this.showSummary.bind(this)}
              onCancel={()=>window.location="."}
            />
          )}
        </div>
      </div>
    )
  }
}

export default class BusinessCasePage extends React.Component {
  render() {
    var menu=(this.props.showMenu===true) ? <ProjectMenu {...this.props}/> : undefined;
    return (
      <Layout {...this.props} projectMenu={menu}>
        <BusinessCase {...this.props}/>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./views/businessCase/BusinessCase.jsx